export default __webpack_public_path__ + "static/media/project-gray-.02f550cc.svg";